import { useState, useMemo, useCallback } from 'react';

interface PanelLayoutOptions {
  defaultLeftVisible?: boolean;
  defaultRightVisible?: boolean;
  defaultLeftMode?: string;
  bothLeftWidth?: string;
  bothRightWidth?: string;
  soloLeftWidth?: string;
  soloRightWidth?: string;
}

export function usePanelLayout(options: PanelLayoutOptions = {}) {
  const {
    defaultLeftVisible = true,
    defaultRightVisible = true,
    defaultLeftMode = '',
    bothLeftWidth = 'w-72',
    bothRightWidth = 'w-80',
    soloLeftWidth = 'w-80',
    soloRightWidth = 'w-96',
  } = options;

  const [leftVisible, setLeftVisible] = useState(defaultLeftVisible);
  const [rightVisible, setRightVisible] = useState(defaultRightVisible);
  const [leftMode, setLeftMode] = useState(defaultLeftMode);

  const leftWidth = useMemo(() => {
    if (!leftVisible) return '';
    if (!rightVisible) return soloLeftWidth;
    return bothLeftWidth;
  }, [leftVisible, rightVisible, bothLeftWidth, soloLeftWidth]);

  const rightWidth = useMemo(() => {
    if (!rightVisible) return '';
    if (!leftVisible) return soloRightWidth;
    return bothRightWidth;
  }, [rightVisible, leftVisible, bothRightWidth, soloRightWidth]);

  const toggleLeft = useCallback(() => setLeftVisible((v) => !v), []);
  const toggleRight = useCallback(() => setRightVisible((v) => !v), []);

  return {
    leftVisible,
    rightVisible,
    leftMode,
    leftWidth,
    rightWidth,
    setLeftVisible,
    setRightVisible,
    setLeftMode,
    toggleLeft,
    toggleRight,
  };
}
